// src/contexts/UserContext.js
import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../api/axios';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    const refreshUserInfo = useCallback(() => {
        api.get('/api/user-info/')
            .then(res => setUserInfo(res.data))
            .catch(err => {
                console.error('유저 정보 로딩 실패', err);
                setUserInfo(null);
            })
            .finally(() => setLoading(false));
    }, []);

    // ✅ 포인트 즉시 반영 (WS에서 +7 오면 이거 호출)
    const bumpPoints = useCallback((delta) => {
        const d = Number(delta || 0);
        if (!d) return;
        setUserInfo(prev => {
            if (!prev) return prev;
            const prevPoints = Number(prev.points || 0);
            return { ...prev, points: prevPoints + d };
        });
    }, []);

    useEffect(() => {
        refreshUserInfo();
    }, [refreshUserInfo]);

    if (loading) return <div>로딩 중입니다...</div>;

    const value = {
        userInfo,
        username: userInfo?.username,
        fetchUserInfo: refreshUserInfo,   // 호환용
        refreshUserInfo,
        setUserInfo,
        bumpPoints,                       // ✅ 추가
    };

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);
